import React from 'react';

// only for NEOU netflix tray
export function displayDetailsOnBottom(duration, gist){
    const category = gist.primaryCategory;
    const concept = gist.featuredTag ? gist.featuredTag.title : "";
    const durationFromRuntime = `${parseInt((gist.runtime+1)/60)}m`;

    return <div className="details_bottom">
    <div className="black_bar">
      {`${duration ? duration.title : durationFromRuntime}${category ? " · " + category.title : ""}`} 
    </div>
    <div className="black_bar">
      {`${concept ? concept + " ·" : ""} ${gist.title}`}
    </div>
  </div>
}

export function displayCategoryItems(item, onlyPrimary){
  let categories = [];
  item.gist.primaryCategory && categories.push(item.gist.primaryCategory.title);
  if(!onlyPrimary && item.categories){
    let secondaryCategory = item.categories.map(e => e.title);
    categories = categories.concat(secondaryCategory)
  }
  return categories;
}